import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

// Parse Firebase configuration from environment variable
let firebaseConfig;
try {
    firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG);
} catch {
    console.error('Missing or invalid VITE_FIREBASE_CONFIG — Firebase will not initialize.');
    firebaseConfig = {};
}

// Initialize Firebase app
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(firebaseApp);

// Initialize Firebase Functions (australia-southeast1 region)
export const firebaseFunctions = getFunctions(firebaseApp, 'australia-southeast1');
